import axios from "axios";
import axiosInstance from "../axiosInstance";
import { Url } from "./constantUrl";
import getHeaders from "./getHeaders";
import * as types from "./types";
import { errorHandler } from "./error/errorHandler.action";
import getHeadersformdata from "./getHeaderFormdata";

export const tutorialListAction = (page, type, search) => (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  let url = API_URL + Url.TUTORIAL_AND_TROUBLE;
  const params = {};

  if (page) {
    params.page = page;
    params.page_size = 15;
  }
  if (type) {
    params.type = type;
  } else {
    params.type = "";
  }
  if (search) {
    params.search = search;
  }
  url += `?${new URLSearchParams(params).toString()}`;
  const options = {
    method: "GET",
    headers: getHeaders(),
    url: url,
  };
  return axiosInstance(options)
    .then((resp) => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_TUTORIAL_AND_TROUBLE, payload: resp });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      errorHandler(error);
    });
};

//  Searched data for tutorial
export const tutorialSearchInputAction = (params = {}) => dispatch => {
  dispatch({ type: types.TUTORIAL_LIST_SEARCH_INPUT, payload: params ? params : null })
}
// ADD CONTENT POST API

export const addContentAction =
  (params = {}) =>
    (dispatch) => {
      const API_URL = localStorage.getItem('countryBackendUrl')
      const url = API_URL + Url.ADD_CONTENT;
      let options = Object.assign(
        { method: "POST" },
        params ? { data: params } : null
      );
      options.headers = getHeadersformdata();
      options.url = url;
      return axiosInstance(options)
        .then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            dispatch({ type: types.POST_ADD_CONTENT, payload: resp });
            return resp;
          } else {
            return null;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    };

// UPDATE CONTENT POST API

export const updateContentAction =
  (params = {}, id) =>
    (dispatch) => {
      const API_URL = localStorage.getItem('countryBackendUrl')
      const url = API_URL + Url.UPDATE_CONTENT + "/" + id;
      let options = Object.assign(
        { method: "POST" },
        params ? { data: params } : null
      );
      options.headers = getHeadersformdata();
      options.url = url;
      return axiosInstance(options)
        .then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            dispatch({ type: types.POST_UPDATE_CONTENT, payload: resp });
            return resp;
          } else {
            return null;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    };

// All checked list in module tutorial List

var paginationCount = 10;
export const allcheckedtutorialAction = (module_id, page) => (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url =
    API_URL +
    Url.CHECKED_UNCHECKED_TUTORIAL +
    `/?module_id=${module_id}` + `&page=${page}&page_size=${paginationCount}`;
  let options = Object.assign({ method: "GET" });
  options.headers = getHeaders();
  options.url = url;
  return axiosInstance(options)
    .then((resp) => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_CHECKED_UNCHECKED_TUTORIAL, payload: resp });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      errorHandler(error);
    });
};

// Get checked and unchecked tutorial list

export const tutorialmoduleListAction = (module_id, page, file_type, vehicle_ids, search) => (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  let url = API_URL + Url.CHECKED_UNCHECKED_TUTORIAL;
  const params = {};

  if (page) {
    params.page = page;
    params.page_size = paginationCount;
  }
  if (module_id) {
    params.module_id = module_id;
  } else {
    params.module_id = "";
  }
  if (file_type) {
    params.file_type = file_type;
  } else {
    params.file_type = "";
  }
  if (vehicle_ids) {
    params.vehicle_ids = vehicle_ids;
  } else {
    params.vehicle_ids = "";
  }
  if (search) {
    params.search = search;
  } else {
    params.search = "";
  }
  url += `?${new URLSearchParams(params).toString()}`;
  const options = {
    method: "GET",
    headers: getHeaders(),
    url: url,
  };
  return axiosInstance(options)
    .then((resp) => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_CHECKED_UNCHECKED_TUTORIAL, payload: resp });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      errorHandler(error);
    });
};


// Active Button  on Traning page

export const buttonHandleAction = (params = {}) => dispatch => {
  dispatch({ type: types.TRAINING_BUTTON, payload: params ? params : null })
}

// Tutorial List Page
export const tutorialListPageinputAction = (params = {}) => dispatch => {
  dispatch({ type: types.TUTORIAL_LIST_PAGE_VALUE, payload: params ? params : null })
}
